/** Deep links into the ShipBob merchant dashboard (format confirmed by Inno, 2026-09). */
export const shipbobWroUrl = (wroId: string): string =>
  `https://web.shipbob.com/app/merchant/#/inventory/receiving/${wroId}/summary/`;
